// Simple query string parser using native URLSearchParams
function parseQueryString(search) {
  const params = new URLSearchParams(search);
  const result = {};
  for (const [key, value] of params.entries()) {
    result[key] = value;
  }
  return result;
}

global.time_sec_jump = 10;
global.formatted_since_just_added = "just added";

global.host = window.location.hostname; // "testcomments5-env.vip8dhubmp.us-west-2.elasticbeanstalk.com";
// In development: frontend runs on 4000 (React dev server), backend on 8089 (default port)
// In production: backend serves frontend, so same port
// Use REACT_APP_API_PORT env var if set, otherwise:
// - localhost: use 8089 (backend default port)
// - production: use same port as frontend, or omit port (browsers default to 80 for HTTP, 443 for HTTPS)
const httpProtocol = window.location.protocol === "https:" ? "https://" : "http://";
var apiPort = process.env.REACT_APP_API_PORT 
  ? process.env.REACT_APP_API_PORT 
  : (global.host == "localhost" || global.host == "127.0.0.1" 
      ? "8089" 
      : window.location.port); // Use explicit port if available, otherwise undefined (default port)
// Only include port in URL if it's explicitly specified and non-standard
// Standard ports: 80 for HTTP, 443 for HTTPS (browsers handle these automatically)
var port = "";
if (apiPort) {
  // Only add port if it's non-standard (not 80 for HTTP, not 443 for HTTPS)
  const isStandardPort = (httpProtocol === "https://" && apiPort === "443") || 
                         (httpProtocol === "http://" && apiPort === "80");
  if (!isStandardPort) {
    port = ":" + apiPort;
  }
}
global.server_url = httpProtocol + global.host + port + "/handle_comments/"; // "http://www.thevcard.net/cms/cms_json.aspx";
// WebSocket path prefix (same for dev and production)
// Backend serves WebSocket on /ws path through the same HTTP server (port 8089 in dev, proxied through Nginx in production)
global.ws_path = process.env.REACT_APP_WS_PATH || "/ws";
// WebSocket port: same as API port (8089 in dev, no port in production)
global.ws_port_suffix = (global.host == "localhost" || global.host == "127.0.0.1") ? port : "";

function handle_win_title() {
  var title_arg = window.location.search;
  if (title_arg !== "") title_arg = title_arg.substr(1) + "&";
  window.location.title_arg = title_arg;
  global.title = parseQueryString(window.location.search).title;
  if (global.title === undefined || global.title === "") {
    global.title = "Root";
  }
}

export default handle_win_title;



// WEBPACK FOOTER //
// ./src/components/global.js